"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personsViewModel = personsViewModel;
const person_1 = require("./person");
function personsViewModel(persons, baseUrl) {
    return persons?.map((person) => (0, person_1.personViewModel)(person, baseUrl)) ?? [];
}
